import { locale as simpleDialog } from '@core-utils/simple-dialog/components/simple-dialog/i18n/en';

export const locale = {
    lang: 'en',
    data: {
        ...simpleDialog.data
    }
};